import _extends from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  font-size: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  border-radius: 100%;\n  margin-right: 8px;\n  width: ", ";\n  height: ", ";\n  background-image: url(\"", "\");\n  background-position: center center;\n  background-size: cover;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  display: flex;\n  align-items: center;\n  font-size: ", ";\n  font-weight: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { parseISO, format } from 'date-fns/fp';
import { variant } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { Card } from './Card';
import { CARD_VARIANT } from './constants';
import { getHeaderVariant } from './utils/responsiveProps';
import { CardInfo } from '../cardInfo/CardInfo';
import { Tag } from '../tag/Tag';
import { Link } from '../link/Link';
var articleCardAuthorStyle = variant({
  key: 'card.article.author'
});
var AuthorInfo = styled.div(_templateObject(), articleCardAuthorStyle, themeGet('card.article.author.fontSize'), themeGet('card.article.author.fontWeight'));
var Avatar = styled.div(_templateObject2(), themeGet('card.article.avatar.size'), themeGet('card.article.avatar.size'), function (props) {
  return props.imgUrl;
});
var articleCardDateStyle = variant({
  key: 'card.article.date'
});
var Date = styled.span(_templateObject3(), articleCardDateStyle, themeGet('card.article.date.fontSize'));
var Head = styled.div(_templateObject4());
export var ArticleCard = function ArticleCard(_ref) {
  var variant = _ref.variant,
      coverUrl = _ref.coverUrl,
      author = _ref.author,
      date = _ref.date,
      dateFormat = _ref.dateFormat,
      title = _ref.title,
      description = _ref.description,
      cardInfoData = _ref.cardInfoData,
      tags = _ref.tags,
      links = _ref.links,
      rest = _objectWithoutProperties(_ref, ["variant", "coverUrl", "author", "date", "dateFormat", "title", "description", "cardInfoData", "tags", "links"]);

  var headerVariant = getHeaderVariant(variant, coverUrl);
  var header =
  /*#__PURE__*/
  React.createElement(Head, null,
  /*#__PURE__*/
  React.createElement(AuthorInfo, {
    variant: headerVariant
  },
  /*#__PURE__*/
  React.createElement(Avatar, {
    imgUrl: author.imgUrl
  }), author.name),
  /*#__PURE__*/
  React.createElement(Date, {
    variant: headerVariant
  }, format(dateFormat, parseISO(date))));
  return (
    /*#__PURE__*/
    React.createElement(Card, _extends({
      variant: variant,
      coverUrl: coverUrl,
      header: header,
      footer: cardInfoData &&
      /*#__PURE__*/
      React.createElement(CardInfo, {
        data: cardInfoData
      })
    }, rest),
    /*#__PURE__*/
    React.createElement(Card.Meta, {
      title: title,
      description: description
    }, tags &&
    /*#__PURE__*/
    React.createElement(Tag.Group, {
      maxCounts: 2
    }, tags), links &&
    /*#__PURE__*/
    React.createElement(Link.Group, {
      maxCounts: 2
    }, links)))
  );
};
ArticleCard.defaultProps = {
  variant: CARD_VARIANT.VERTICAL,
  author: {},
  dateFormat: 'yyyy-MM-dd'
};
ArticleCard.Meta = Card.Meta;